<div class="wrapper">
  <form [formGroup]="form">
    <ng-container *ngIf="isShowForCategory || !this.isModelLevel; else usualModel">
      <div class="two-items">
        <div class="form-component">
          <mat-form-field>
            <mat-select formControlName="Layer" matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}">
              <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
              </mat-option>
            </mat-select>
            <mat-placeholder>{{
                layers.length ? ("configurationTab.layer" | translate) : ("configurationTab.noLayer" | translate)
              }}
            </mat-placeholder>
          </mat-form-field>
          <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
        </div>

        <div class="form-component main-color">
          <mee-color-picker [position]="'left'" formControlName="MainColor"></mee-color-picker>
        </div>
      </div>

      <div class="two-items">
        <div class="form-component">
          <mat-form-field>
            <input
              matInput
              matTooltip="{{ 'configurations-fields.tooltips.Header' | translate }}"
              type="text"
              placeholder="{{ 'configurations-fields.Header' | translate }}"
              formControlName="Title"
              name="Header"
            />
            <button mat-button type="button" *ngIf="isTitleNotEmpty" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearTitle()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="form-component toggle-only-second"
             *ngIf="isDisplayForCurrentSourceType(configurationFields.IsExcludedFromProcessing)">
          <mat-slide-toggle
            formControlName="IsExcludedFromProcessing"
            matTooltip="{{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}"
            color="primary"
          >
            {{ "configurations-fields.tooltips.ExcludeFromProcessing" | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </ng-container>

    <ng-template #usualModel>
      <div class="two-items">
        <div class="form-component">
          <mat-form-field>
            <mat-select formControlName="Layer" matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}">
              <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
              </mat-option>
            </mat-select>
            <mat-placeholder>{{
                layers.length ? ("configurationTab.layer" | translate) : ("configurationTab.noLayer" | translate)
              }}
            </mat-placeholder>
          </mat-form-field>

          <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
        </div>

        <div class="form-component">
          <mat-form-field>
            <mat-select matTooltip="{{ 'configurations-fields.tooltips.ObjectType' | translate }}"
                        formControlName="ObjectType">
              <mat-option [value]="null">{{ "configurationTab.notSelected" | translate }}</mat-option>
              <mat-option *ngFor="let objectType of objectTypesOptions" [value]="objectType.value">
                {{ objectType.title | translate }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ "configurations-fields.ObjectType" | translate }}</mat-placeholder>
          </mat-form-field>
        </div>
      </div>

      <div class="two-items">
        <div class="form-component">
          <mat-form-field>
            <input
              matInput
              matTooltip="{{ 'configurations-fields.tooltips.Header' | translate }}"
              type="text"
              placeholder="{{ 'configurations-fields.Header' | translate }}"
              formControlName="Title"
              name="Header"
            />
            <button mat-button type="button" *ngIf="isTitleNotEmpty" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearTitle()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="form-component main-color">
          <mee-color-picker [position]="ColorPickerPosition.Left" formControlName="MainColor"></mee-color-picker>
        </div>
      </div>

      <div class="one-item" formGroupName="ObjectTypeConfiguration">
        <div class="form-component" *ngIf="isDisplayForCurrentSourceType(configurationFields.WorkPacks)">
          <mat-form-field>
            <mat-label>{{ 'sources.configuration.SplitModel' | translate }}</mat-label>
            <mat-select formControlName="WorkpackAttribute" [compareWith]="compareWorkPacksFn">
              <mat-option [value]="null">{{ 'commonPhrases.None' | translate }}</mat-option>
              <mat-option *ngFor="let workPack of workPacks" [value]="workPack">
                {{ workPack.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div
          class="form-component"
          *ngIf="node.ObjectTypeConfiguration.Is12dModel && isDisplayForCurrentSourceType(configurationFields.IfcCategorizationStrategy)"
        >
          <mat-form-field matTooltip="{{ 'configurations-fields.IfcCategorizationStrategy' | translate }}">
            <mat-select
              placeholder="{{ 'configurations-fields.IfcCategorizationStrategy' | translate }}"
              formControlName="IfcCategorizationStrategy"
            >
              <mat-option
                *ngFor="let ifcCategorizationStrategy of ifcCategorizationStrategyOptions"
                [value]="ifcCategorizationStrategy.value"
              >
                {{ ifcCategorizationStrategy.title | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="object-configuration-title" [ngClass]="{'with-check-location': isCheckLocation}"
           *ngIf="isShowObjectConfigurationTitle()">
        <p> {{ "configurations-fields.ObjectConfigurationTitle" | translate }} </p>

        <button
          *ngIf="isCheckLocation"
          [disabled]="isCheckLocationDisable"
          (click)="checkLocation()"
          mat-button
          class="check-location">
          <mat-icon svgIcon="check-location"></mat-icon>
          {{ "configuration-page.buttons.check-location" | translate }}
        </button>
      </div>

      <div class="two-items">
        <div class="form-component" *ngIf="isShowProjectionType()">
          <mat-form-field matTooltip="{{ 'configurations-fields.tooltips.ProjectionType' | translate | titlecase }}">
            <mat-select
              [formControl]="projectionTypeControl"
              placeholder="{{ 'configurations-fields.tooltips.ProjectionType' | translate | titlecase }}"
              (selectionChange)="onProjectionTypeChange($event)"
            >
              <mat-option *ngFor="let projectionType of projectionTypeOptions"
                          [value]="projectionType">
                {{ getProjectionTypeLabel(projectionType) }}
              </mat-option>

              <ng-container *ngIf="isCustomCoordinateSystemDisplay">
                <mat-option *ngFor="let coordinateSystem of customCoordinateSystems" [value]="coordinateSystem.Id">
                  {{ coordinateSystem.Name }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>

        <ng-container
          *ngIf="isDisplayForCurrentSourceType(configurationFields.IsMeshInteractionEnabled)"
          formGroupName="ObjectTypeConfiguration"
        >
          <div class="form-component toggle">
            <mat-slide-toggle formControlName="IsMeshInteractionEnabled" name="EnableModelInteractions" color="primary">
              {{ "sources.fields-placeholders.isEnableModelInteractions" | translate }}
            </mat-slide-toggle>
          </div>
        </ng-container>
      </div>

      <div class="two-items with-hint">
        <div
          class="form-component coordinate-system"
          [ngClass]="{ 'with-measurement': isDisplayForCurrentSourceType(configurationFields.MeasurementSystem) }"
          *ngIf="isShowCoordinateSystem"
          formGroupName="ObjectTypeConfiguration"
        >
          <mat-form-field *ngIf="isDisplayForCurrentSourceType(configurationFields.CoordinateSystem)">
            <input
              formControlName="CoordinateSystem"
              matInput
              type="number"
              min="1"
              matTooltip="{{ 'configurations-fields.tooltips.CoordinateSystem' | translate }}"
              placeholder="{{ 'configurations-fields.CoordinateSystem' | translate }}"
            />

            <ng-container *ngIf="!isDisplayForCurrentSourceType(configurationFields.MeasurementSystem)">
              <ng-container [ngTemplateOutlet]="epsgTip"></ng-container>
            </ng-container>

          </mat-form-field>

          <mat-form-field
            *ngIf="isDisplayForCurrentSourceType(configurationFields.MeasurementSystem)"
          >
            <mat-select placeholder="UoM" formControlName="MeasurementSystem"
                        matTooltip="{{ 'configurations-fields.tooltips.MeasurementSystem' | translate }}"
            >
              <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions"
                          [value]="measurementSystemOption.value">
                {{ measurementSystemOption.title }}
              </mat-option>
            </mat-select>

            <ng-container [ngTemplateOutlet]="epsgTip"></ng-container>

          </mat-form-field>

          <ng-template #epsgTip>
            <img (click)="openEpsgHintDialog($event)"
                 class="hint-icon"
                 [ngStyle]="{ 'left' : isDisplayForCurrentSourceType(configurationFields.MeasurementSystem) ? '55px' : '245px'}"
                 src="/assets/img/icons/help-question.svg" alt="hint-icon"
                 matTooltip="{{ 'configurations-fields.tooltips.СoordinateSystemHint' | translate }}"
            >
          </ng-template>
        </div>

        <div class="form-component with-measurement"
             *ngIf="isShowVerticalDatum()">
          <mee-vertical-datum [espg]="espg" formControlName="VerticalDatum"></mee-vertical-datum>

          <mat-form-field matTooltip="{{ 'configurations-fields.tooltips.MeasurementSystem' | translate }}">
            <mat-select placeholder="UoM" formControlName="VerticalMeasurementSystem">
              <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions"
                          [value]="measurementSystemOption.value">
                {{ measurementSystemOption.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="two-items two-toggles" formGroupName="ObjectTypeConfiguration">
        <div
          class="form-component toggle double-side-interaction"
          *ngIf="isDisplayForCurrentSourceType(configurationFields.EnableDoubleSideInteraction)"
        >
          <mat-slide-toggle
            formControlName="EnableDoubleSideInteraction"
            matTooltip="{{ 'configurations-fields.tooltips.EnableDoubleSideInteraction' | translate }}"
            color="primary"
          >
            {{ "configurations-fields.tooltips.EnableDoubleSideInteraction" | translate }}
          </mat-slide-toggle>
        </div>

        <div class="form-component toggle" *ngIf="isDisplayExtendModelToggles">
          <mat-slide-toggle formControlName="FullModel" name="ExtendViewingRange" color="primary">
            {{ "sources.fields-placeholders.isUseFullModel" | translate }}
          </mat-slide-toggle>
        </div>
      </div>

      <div class="configuration-manual-fields" *ngIf="isShowManualCoordinatesFields"
           formGroupName="ObjectTypeConfiguration">
        <div class="three-items">
          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                placeholder="{{ 'configurations-fields.Altitude' | translate }}"
                formControlName="Altitude"
                name="Altitude"
              />
            </mat-form-field>
          </div>

          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                placeholder="{{ 'configurations-fields.Latitude' | translate }}"
                formControlName="Latitude"
                name="Latitude"
              />
            </mat-form-field>
          </div>

          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                placeholder="{{ 'configurations-fields.Longitude' | translate }}"
                formControlName="Longitude"
                name="Longitude"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="three-items">
          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                matTooltip="{{ 'configurations-fields.Pitch' | translate }}"
                placeholder="{{ 'configurations-fields.Pitch' | translate }}"
                formControlName="Pitch"
                name="Pitch"
              />
            </mat-form-field>
          </div>

          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                matTooltip="{{ 'configurations-fields.Roll' | translate }}"
                placeholder="{{ 'configurations-fields.Roll' | translate }}"
                formControlName="Roll"
                name="Roll"
              />
            </mat-form-field>
          </div>

          <div class="form-component">
            <mat-form-field>
              <input
                matInput
                type="number"
                matTooltip="{{ 'configurations-fields.Yaw' | translate }}"
                placeholder="{{ 'configurations-fields.Yaw' | translate }}"
                formControlName="Yaw"
                name="Yaw"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <p class="additional-details-title">
        {{ "configurations-fields.AdditionalDetails" | translate }}
      </p>

      <div class="two-items">

        <div class="form-component toggle-only-second"
             *ngIf="isDisplayForCurrentSourceType(configurationFields.IsExcludedFromProcessing)">
          <mat-slide-toggle
            formControlName="IsExcludedFromProcessing"
            matTooltip="{{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}"
            color="primary"
          >
            {{ "configurations-fields.tooltips.ExcludeFromProcessing" | translate }}
          </mat-slide-toggle>
        </div>

        <div class="form-component">
          <mat-form-field>
            <mat-select matTooltip="{{ 'configurations-fields.tooltips.AltitudeMode' | translate }}"
                        formControlName="AltitudeMode">
              <mat-option *ngFor="let mode of altitudeModesOptions" [value]="mode.value">
                {{ mode.title | translate }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ "configurations-fields.AltitudeMode" | translate }}</mat-placeholder>
          </mat-form-field>
        </div>
      </div>

      <div class="two-items two-toggles floors-splitting">
        <div class="form-component toggle floor-elevation"
             *ngIf="isDisplayForCurrentSourceType(configurationFields.FloorElevation)">
          <mat-slide-toggle
            #floorSplittingToggle
            formControlName="IsFloorSplittingEnabled"
            matTooltip="{{ 'configurations-fields.tooltips.FloorElevation' | translate }}"
            color="primary"
          >
            {{ "configurations-fields.tooltips.FloorElevation" | translate }}
          </mat-slide-toggle>
        </div>

        <div class="form-component toggle ifc-mapping" *ngIf="isShowIfcFloorsConfiguration">
          <mat-slide-toggle
            #ifcMappingToggle
            (change)="onIfcMappingChange($event)"
            [disabled]="!isIfcMappingEnabled"
            matTooltip="{{ 'configurations-fields.tooltips.IfcStorey' | translate }}"
            color="primary"
          >
            {{ "configurations-fields.tooltips.IfcStorey" | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </ng-template>

    <div class="floors-ifc-mapping" *ngIf="isShowIfcMapping">
      <mat-spinner diameter="60" *ngIf="isCompanyFloorsLoading; else floorsTable"></mat-spinner>

      <ng-template #floorsTable>
        <mee-floors-ifc-mapping formControlName="FloorConfiguration"
                                [companyFloors]="companyFloors"></mee-floors-ifc-mapping>
      </ng-template>
    </div>
  </form>
</div>
